import { render, staticRenderFns } from "./button-ellipsis.vue?vue&type=template&id=64ba32f6&scoped=true&"
import script from "./button-ellipsis.vue?vue&type=script&lang=js&"
export * from "./button-ellipsis.vue?vue&type=script&lang=js&"
import style0 from "./button-ellipsis.vue?vue&type=style&index=0&id=64ba32f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ba32f6",
  null
  
)

export default component.exports